import { EyeOffIcon } from "../../../../../common/icons/EyeOffIcon";

export const DisabledSubStatusIcon = () => {
  return <EyeOffIcon />;
};
